import { jsx as _jsx } from "react/jsx-runtime";
import { groupMediaSrc } from '../api/messaging';
/** Images et vidéo d'un message de groupe (fiche groupe, signalements). */
export function GroupAttachments({ attachments }) {
    if (attachments.length === 0)
        return null;
    return (_jsx("div", { className: "flex flex-wrap gap-2 mt-1.5", children: attachments.map((a) => {
            if (a.status === 'processing') {
                return _jsx("span", { className: "text-[11px] text-gray-400 italic", children: "Vid\u00E9o en pr\u00E9paration..." }, a.id);
            }
            if (a.status === 'failed') {
                return _jsx("span", { className: "text-[11px] text-red-400 italic", children: "La vid\u00E9o n'a pas pu \u00EAtre trait\u00E9e." }, a.id);
            }
            if (a.kind === 'video') {
                return (_jsx("video", { src: groupMediaSrc(a.url), poster: groupMediaSrc(a.thumb_url), controls: true, preload: "none", className: "max-w-[320px] max-h-[240px] rounded-lg bg-black" }, a.id));
            }
            return (_jsx("a", { href: groupMediaSrc(a.url), target: "_blank", rel: "noreferrer", children: _jsx("img", { src: groupMediaSrc(a.thumb_url ?? a.url), alt: "Image jointe au message", loading: "lazy", className: "w-28 h-28 object-cover rounded-lg border border-gray-100" }) }, a.id));
        }) }));
}
